import React from 'react';
import PropTypes from 'prop-types';

import { StyledInputTooltip } from './styled';

function InputTooltip(props) {
  const { isVisible = false, message = '', radio = false } = props;

  return (
    <StyledInputTooltip isVisible={isVisible} radio={radio}>
      <span>{message}</span>
    </StyledInputTooltip>
  );
}

InputTooltip.propTypes = {
  isVisible: PropTypes.bool,
  message: PropTypes.string.isRequired,
  radio: PropTypes.bool,
};

export default InputTooltip;
